import type { SVGProps } from 'react'
const SvgSyFunnel = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				fillRule="evenodd"
				d="M4.564 2.25c-1.276 0-2.314 1.063-2.314 2.34v.937c0 .84.319 1.648.893 2.258l4.845 5.152.02.008H8a4.4 4.4 0 0 1 1.25 3.078v4.573c0 .828.955 1.415 1.691 1.015l.002-.002 2.76-1.502v-.002A2.06 2.06 0 0 0 14.77 18.3v-2.287c0-1.15.444-2.25 1.234-3.065l.008-.01 4.845-5.152h.002c.573-.61.891-1.417.891-2.258V4.59c0-1.277-1.038-2.34-2.314-2.34zm0 1.5h14.872c.451 0 .814.361.814.84v.937c0 .46-.175.9-.484 1.23l-4.838 5.145a5.9 5.9 0 0 0-1.658 4.11v2.287c0 .21-.113.396-.286.49l-2.234 1.217v-3.983c0-1.54-.602-3.015-1.668-4.113l-.008-.014-.008-.002-4.83-5.136c-.31-.33-.486-.77-.486-1.23V4.59c0-.478.363-.84.814-.84"
				clipRule="evenodd"
			/>
			<path
				d="M10 6.25a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h10.5a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75z"
				opacity={0.4}
			/>
		</g>
	</svg>
)
export default SvgSyFunnel
